import { theme } from "@meiden-connect/ui";
import { light } from "@meiden-connect/ui/default-theme";
import { useEffect } from "react";
import { CanvasView } from "../features/canvas/canvas-view";
import { isEmbedMode } from "../lib/embed-mode";
import { readCreateCanvasNameFromUrl } from "../lib/canvas-create-name";

interface Props {
  readonly canvasId: string;
}

export function CanvasPage({ canvasId }: Props): JSX.Element {
  // TOP のテーマ設定に関わらず、キャンバス画面はライトモード固定で表示する。
  // setPreference だけでは、同一オリジンの別タブでテーマが変更されたときに共有の storage
  // イベントを受けて body がダークテーマへ戻り、ツールバーだけ暗色用の配色になることがある。
  // キャンバスの DOM 境界にもライトテーマを付け、後から body のテーマが変わっても配下の
  // UI コンポーネントへライト用 CSS 変数が継承され続けるようにする。
  useEffect(() => {
    theme.setPreference("light");
  }, []);

  // 新規キャンバス作成時の初期名（Connect Note の「新しいキャンバス」からの記事タイトル引き継ぎ）。
  // 未作成キャンバスの lazy create 時のみ採用され、既存キャンバスを開く場合は無視される。
  const createName = readCreateCanvasNameFromUrl(window.location.search);

  // 参照専用の埋め込みモード（Connect Note からの iframe）では編集 UI を持たないビューを描画する。
  return (
    <div className={light} data-testid="canvas-light-theme-boundary">
      <CanvasView canvasId={canvasId} embed={isEmbedMode()} createName={createName} />
    </div>
  );
}
